import styled from "styled-components";

export const ChartContainer = styled.div`
  width: 80%;
  height: 24rem;
  margin: auto;
  margin-bottom: 2.5rem;
`;